import { Button, useMantineTheme } from "@mantine/core";

type Props = {
  displayText: string;
  isSelected: boolean;
  onClick: () => void;
};

export const AnswerOptionButton = ({ displayText, isSelected, onClick }: Props) => {
  const theme = useMantineTheme();

  return (
    <Button
      size="lg"
      radius="md"
      variant={"outline"}
      styles={{
        root: {
          borderColor: isSelected ? theme.colors.lightBlue[0] : theme.white,
          borderWidth: isSelected ? "3px" : "1px",
          color: theme.white,
          transition: "all 0.1s ease-out",
          // height: "auto",
          // minHeight: "48px",
        },
        label: {
          whiteSpace: "normal",
          wordBreak: "keep-all",
          padding: "8px 0",
          lineHeight: "1.2",
        },
      }}
      fullWidth
      onClick={onClick}
    >
      {displayText}
    </Button>
  );
};
